(function($) {
    $('.pushy .submenu-trigger').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();

        $(this).closest('li').find('> ul').slideToggle();
        $(this).toggleClass('active');
    });
})(jQuery);